<template>
  <div>
    <page-title-bar :customTitle="customTitle"></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-toolbar :elevation="0" height="auto">
            <v-layout row justify-end align-center>
              <v-flex xs12 md4>
                <v-layout row class="ma-0 py-2">
                  <div>
                    <v-flex class="py-1">Số dư đầu kỳ</v-flex>
                    <v-flex class="py-1">Tổng thu</v-flex>
                    <v-flex class="py-1">Tổng chi</v-flex>
                    <v-flex class="py-1">Số dư cuối kỳ</v-flex>
                  </div>
                  <div>
                    <v-flex class="py-1 text-right">{{
                      this.opening_balance | formatCurrency
                    }}</v-flex>
                    <v-flex class="py-1 text-right">{{
                      this.total_income | formatCurrency
                    }}</v-flex>
                    <v-flex class="py-1 text-right">{{
                      this.total_expense | formatCurrency
                    }}</v-flex>
                    <v-flex class="py-1 text-right">
                      {{ this.end_balance | formatCurrency }}
                    </v-flex>
                  </div>
                </v-layout>
              </v-flex>
              <v-flex row xs12 md8>
                <v-layout row justify-space-between align-center>
                  <v-flex xs12 md4>
                    <v-select
                      label="Tài khoản"
                      :disabled="loader"
                      v-model="chosen_wallet_account_id"
                      :items="list_wallet_account"
                      item-text="name"
                      item-value="id"
                      prepend-icon="account_balance_wallet"
                      required
                      hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menu_date_start"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="date_start"
                        label="Ngày bắt đầu"
                        :disabled="loader"
                        prepend-icon="event"
                        readonly
                        hide-details
                      ></v-text-field>
                      <v-date-picker
                        locale="vi-VI"
                        v-model="date_start"
                        @input="menu_date_start = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menu_date_end"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      hide-details
                    >
                      <v-text-field
                        slot="activator"
                        v-model="date_end"
                        label="Ngày kết thúc"
                        :disabled="loader"
                        prepend-icon="event"
                        readonly
                        hide-details
                      ></v-text-field>
                      <v-date-picker
                        locale="vi-VI"
                        v-model="date_end"
                        @input="menu_date_end = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout row justify-space-between align-center>
                  <v-flex shrink>
                    <div class="text-right">
                      <v-btn
                        @click="triggerDialogUploadSaoKe"
                        color="green"
                        dark
                        >Upload sao kê</v-btn
                      >
                      <span>
                        <v-btn
                          :loader="export_csv.loader"
                          @click="exportCSV"
                          color="green"
                          dark
                          >XUẤT EXCEL</v-btn
                        >
                        <export-csv-button
                          :trigger="export_csv.trigger"
                          :title="export_csv.title"
                          :rows="export_csv.rows"
                        ></export-csv-button>
                      </span>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-toolbar>
          <div class="mt-3">
            <v-layout row wrap layout justify-end align-center>
              <v-flex xs12 md8>
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Tìm kiếm"
                  hide-details
                  :search="search"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-card>
              <app-section-loader :status="loader"></app-section-loader>
              <v-data-table
                disable-initial-sort
                :headers="headers"
                :items="items"
                item-key="id"
                :loading="loader"
                :rows-per-page-items="rowPerPage"
                :search="search"
              >
                <template #items="props">
                  <tr>
                    <td class="text-center px-0">
                      <v-menu offset-y>
                        <v-btn icon slot="activator">
                          <v-icon small color="#464D69">settings</v-icon>
                        </v-btn>
                        <v-list>
                          <v-list-tile @click="showDetail(props.item)">
                            <v-list-tile-action>
                              <v-icon
                                small
                                class="zmdi zmdi-assignment"
                              ></v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title
                              >Phiếu chi tiết</v-list-tile-title
                            >
                          </v-list-tile>
                          <v-list-tile
                            @click="
                              triggerDialogCreateInternalBankTransfer(
                                props.item
                              )
                            "
                            :disabled="!!props.item.bank_internal_transfer_id"
                          >
                            <v-list-tile-action>
                              <v-icon
                                small
                                class="zmdi zmdi-assignment"
                              ></v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title
                              >Phiếu chuyển tiền ngân hàng nội
                              bộ</v-list-tile-title
                            >
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </td>
                    <td class="text-center text-no-wrap pr-1">
                      <span
                        :class="
                          props.item.status === 'Finalized'
                            ? 'v-badge primary'
                            : 'v-badge warning'
                        "
                      >
                        {{ props.item.status }}
                      </span>
                    </td>
                    <td class="text-center text-no-wrap px-1">
                      {{ props.index + 1 }}
                    </td>
                    <td class="text-center text-no-wrap px-1">
                      {{ props.item.bank_receipt_id }}
                    </td>
                    <td class="text-center text-no-wrap px-1">
                      {{ props.item.date_action | formatTimeServer }}
                    </td>
                    <td class="text-right text-no-wrap">
                      {{
                        (props.item.amount > 0 && props.item.amount)
                          | formatCurrency
                      }}
                    </td>
                    <td class="text-right text-no-wrap">
                      {{
                        (props.item.amount < 0 && -props.item.amount)
                          | formatCurrency
                      }}
                    </td>
                    <td class="text-right text-no-wrap">
                      {{ props.item.balance | formatCurrency }}
                    </td>
                    <td class="text-right text-no-wrap">
                      {{ props.item.accumulated_balance | formatCurrency }}
                    </td>
                    <td style="min-width: 200px" class="text-left">
                      {{ props.item.description_computed }}
                    </td>
                    <td class="text-left">
                      {{ props.item.description }}
                    </td>
                  </tr>
                </template>
                <template #no-data>
                  Chưa có thông tin
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <dialog-upload-sao-ke
      :dialog="trigger_dialog_upload_sao_ke"
      :chosen_wallet_account_id="chosen_wallet_account_id"
      @changeDialogState="trigger_dialog_upload_sao_ke = $event"
      @reloadTable="getData"
    >
    </dialog-upload-sao-ke>
    <so-tien-ngan-hang-tao-phieu-chi-tiet-dialog
      v-if="selected_transaction"
      :dialogDetail.sync="dialogDetail"
      :transaction="selected_transaction"
      @reloadTable="getData"
    />
    <dialog-tao-phieu-chuyen-tien-ngan-hang-noi-bo
      v-if="selected_transaction"
      :dialog="trigger_dialog_create_internal_bank_transfer"
      @changeDialogState="trigger_dialog_create_internal_bank_transfer = $event"
      :transaction="selected_transaction"
      @reloadTable="getData"
    />
  </div>
</template>

<script>
import moment from "moment";
import ExportCsvButton from "Components/ExportExcel/ExportCsvButton.vue";
import {
  BANK_ACCOUNT_TYPE_LIST,
  CASH_AND_BANK_ACCOUNT_LIST,
  INCOME_AND_EXPENSE_ACCOUNT_OPTIONS,
} from "Constants/db-config.js";
import { formatTimeServer, translateWalletName } from "Helpers";
import { buildParamQuery } from "Helpers";
import DialogUploadSaoKe from "./DialogUploadSaoKe.vue";
import DialogTaoPhieuChuyenTienNganHangNoiBo from "./DialogTaoPhieuChuyenTienNganHangNoiBo.vue";
import SoTienNganHangTaoPhieuChiTietDialog from "./SoTienNganHangTaoPhieuChiTietDialog.vue";
import api from "../../../api";

export default {
  name: "so-tien-ngan-hang",
  components: {
    ExportCsvButton,
    DialogUploadSaoKe,
    SoTienNganHangTaoPhieuChiTietDialog,
    DialogTaoPhieuChuyenTienNganHangNoiBo,
  },
  data() {
    return {
      loader: false,
      headers: [
        { text: "Thao tác", align: "center", sortable: false, class: "pr-1" },
        {
          text: "Status",
          align: "center",
          sortable: false,
          value: "status",
          class: "px-1",
        },
        {
          text: "Số thứ tự",
          align: "center",
          sortable: false,
          value: "index",
          class: "px-1",
        },
        {
          text: "Số chứng từ NH",
          align: "center",
          sortable: true,
          value: "bank_receipt_id",
          class: "px-1",
        },
        {
          text: "Ngày giao dịch",
          align: "center",
          sortable: true,
          value: "date_action",
          class: "px-1",
        },
        {
          text: "Số tiền thu",
          align: "center",
          sortable: true,
          value: "amount",
        },
        {
          text: "Số tiền chi",
          align: "center",
          sortable: true,
          value: "amount",
        },
        {
          text: "Số dư",
          align: "center",
          sortable: true,
          value: "balance",
        },
        {
          text: "Số dư cộng dồn",
          align: "center",
          sortable: true,
          value: "accumulated_balance",
        },
        {
          text: "Diễn giải",
          align: "left",
          sortable: false,
          value: "description_computed",
        },
        {
          text: "Nội dung chi tiết",
          align: "left",
          sortable: false,
          value: "description",
        },
      ],
      export_csv: {
        loader: false,
        trigger: false,
        title: "",
        rows: [],
      },
      items: [],
      rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
      menu_date_start: false,
      menu_date_end: false,
      date_start: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      date_end: new Date().toISOString().substring(0, 10),
      accumulated_balance: 0,
      chosen_wallet_account_id: 0,
      opening_balance: 0,
      end_balance: 0,
      total_income: 0,
      total_expense: 0,
      trigger_dialog_upload_sao_ke: false,
      selected_transaction: null,
      dialogDetail: false,
      trigger_dialog_create_internal_bank_transfer: false,
      search: "",
    };
  },
  computed: {
    customTitle() {
      return "Sổ " + translateWalletName(this.chosen_wallet_account_id);
    },
    list_wallet_account() {
      return (
        (
          this.$store.state.app.wallets &&
          this.$store.state.app.wallets.filter((item) =>
            BANK_ACCOUNT_TYPE_LIST.includes(item.name)
          )
        ).map((item) => {
          return {
            ...item,
            ...CASH_AND_BANK_ACCOUNT_LIST[item.name],
          };
        }) || []
      );
    },
  },
  watch: {
    date_start: function(nv) {
      this.getData();
    },
    date_end: function(nv) {
      this.getData();
    },
    chosen_wallet_account_id: function(nv) {
      this.getData();
    },
    list_wallet_account: function(nv) {
      if (!this.chosen_wallet_account_id) {
        this.chosen_wallet_account_id = nv[0].id;
      }
    },
  },
  mounted() {
    if (this.list_wallet_account.length) {
      this.chosen_wallet_account_id = this.list_wallet_account[0].id;
    }

    this.getData();
  },
  created() {},
  methods: {
    getData: async function() {
      this.loader = true;

      const params = {
        dateStart: this.date_start,
        dateEnd: this.date_end,
        walletAccountId: this.chosen_wallet_account_id,
      };
      const query = buildParamQuery(params);
      const result = (await api.getBankTransactions(query)).data || [];

      this.total_expense = 0;
      this.total_income = 0;
      this.opening_balance = 0;
      this.end_balance = 0;

      this.items = result
        .sort((a, b) => {
          const a_date_action = new Date(a.date_created);

          const b_date_action = new Date(b.date_created);

          if (a_date_action < b_date_action) return -1;
          if (a_date_action > b_date_action) return 1;

          return a.day_order_index - b.day_order_index;
        })
        .map((item) => {
          if (item.amount < 0) this.total_expense -= item.amount;
          else if (item.amount > 0) this.total_income += item.amount;

          // Xác định loại thu/chi
          let type = "Khác";

          if (item.type) {
            const receipt_type = INCOME_AND_EXPENSE_ACCOUNT_OPTIONS.find(
              (receipt_type) => receipt_type.value === item.type
            );
            type = receipt_type && receipt_type.text;
          }

          return {
            ...item,
            date_action: formatTimeServer(
              item.date_collected || item.date_created,
              "YYYY-MM-DD"
            ),
            balance: item.amount,
            accumulated_balance: item.balance,
            type,
          };
        });

      if (this.items.length > 0) {
        const first_transaction = this.items[0];
        this.opening_balance =
          first_transaction.accumulated_balance - first_transaction.amount;
        this.end_balance = this.items[
          this.items.length - 1
        ].accumulated_balance;
      }

      // Trỏ lại giao dịch đang mở sang bản mới vừa tải về.
      // Trước đây selected_transaction vẫn giữ object cũ, nên khi lưu lỗi một phần
      // (các request chạy song song, không atomic) dialog vẫn hiển thị state cũ:
      // phiếu đã tạo thành công lại không có _id/isEdit -> bấm Lưu lại là tạo TRÙNG (NT-250).
      // Gán lại sẽ kích hoạt watcher `transaction` trong dialog -> updateReceiptListData().
      if (this.selected_transaction) {
        const refreshed_transaction = this.items.find(
          (item) => item._id === this.selected_transaction._id
        );

        if (refreshed_transaction) {
          this.selected_transaction = refreshed_transaction;
        }
      }

      this.loader = false;
    },
    showDetail: function(transaction) {
      this.selected_transaction = transaction;
      this.dialogDetail = true;
    },
    triggerDialogCreateInternalBankTransfer: function(transaction) {
      this.selected_transaction = transaction;
      this.trigger_dialog_create_internal_bank_transfer = true;
    },
    exportCSV: function() {
      const rows = this.items.map((item) => {
        const row = {};
        for (let field of this.headers) {
          row[field.text] = item[field.value];
        }
        return { ...row, "Số thứ tự": item.index + 1 };
      });
      this.export_csv.rows = rows;
      this.export_csv.title = `SoNganHang_${this.date_start}_${this.date_end}`;
      this.export_csv.trigger = !this.export_csv.trigger;
    },
    triggerDialogUploadSaoKe: function() {
      this.trigger_dialog_upload_sao_ke = true;
    },
  },
};
</script>
